import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=1c058460&"
import script from "./TaskView.vue?vue&type=script&lang=ts&"
export * from "./TaskView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports